export const getPaperStyles = (isMobile: boolean) => ({
  width: isMobile ? "100%" : "320px",
  backgroundColor: "#FFFFFF",
  color: "#03222F",
});

export const mobileMenuStyles = {
  header: {
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    pb: 0,
  },
  title: {
    fontWeight: 600,
    color: "#03222F",
  },
  closeButton: {
    color: "#03222F",
  },
  listButton: {
    py: 1,
    "&.active": {
      backgroundColor: "#E5E9EB",
      borderRadius: "8px",
    },
    "&:hover": {
      backgroundColor: "#F2F4F5",
      borderRadius: "8px",
    },
  },
  footer: {
    mt: "auto",
  },
  divider: {
    backgroundColor: "#E5E9EB",
  },
  userContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    p: 2,
    mb: 1,
  },
  avatar: {
    width: 40,
    height: 40,
    bgcolor: "#E0E7EA",
  },
  userName: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#03222F",
  },
  userEmail: {
    fontSize: "12px",
    color: "#596166",
  },
  logout: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    p: 2,
    mb: 1,
    mr: 2,
  },
  logoutIcon: {
    color: "#21262B",
  },
};

export const getOptionTextStyles = (isMobile: boolean) => ({
  fontSize: isMobile ? "16px" : "18px",
});
